<template>
  <TaktareaDetails>
    <template #header>
      <StandardFlexBox
        @click.native="$router.push({name: `${location}TrainDetails`})"
        justify_content="center"
        align_content="center"
        height="100%"
        class="hover"
      >
        <v-icon>chevron_left</v-icon>
        <TText large :text="train.name" />
        <TText style="margin:0px 5px;" large text="/" />
        <TText large :text="taktarea.name" />
      </StandardFlexBox>
    </template>
    <template #body>
      <div class="taktarea-content">
        <transition name="subage-slide-in">
          <router-view />
        </transition>
      </div>
    </template>
  </TaktareaDetails>
</template>
<script>
  // import {
  //   // mapActions,
  //   mapGetters
  // } from 'vuex';
  import TaktareaDetails from '@/components/ProjectWallet/TaktareaDetails.component.vue'
  import { TrainTaktareaDetailsMixin } from '@/mixins/TrainTaktareaDetails.mixin.js'
  export default {
    props: [],
    mixins: [
      TrainTaktareaDetailsMixin
    ],
    components: {
      TaktareaDetails,
    },
    created() {
      this.requestUObject({
        url: [
          {projects:this.$route.params.project_id},
          {trains:this.$route.params.train_id},
          {taktareas:this.$route.params.taktarea_id},
          {showWithEntitiesNormalized:''}
        ]
      });
    },
    computed: {

    },
    methods: {

    }
  }
</script>
<style scoped>
.taktarea-content {
  position: relative;
  overflow: auto;
  flex-shrink: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  width: 100%;
  /* height: calc(100% - 70px); */
  height: 100%;
}
.hover {
  cursor: pointer;
}
</style>
